import React, {Component, Fragment} from "react";
import loading from "./images/25.gif";
import notavailable from "./images/notavailable.png";
import PinchZoomPan from "react-responsive-pinch-zoom-pan";
import './safeimage.css';
import {Button} from "reactstrap";

export class SafeZoomImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      errored: false
    }
  }

  onError() {
    this.setState({errored: true});
  }

  onLoad() {
    this.setState({loaded: true});
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.src !== this.props.src) {
      this.setState({loaded: false, errored: false});
    }
    return true;
  }

  render() {
    return (
      <Fragment>
        {!this.state.loaded && !this.state.errored && (
          <img src={loading} style={{marginTop: 50}}/>
        )}
        {this.state.errored ?
          <img src={notavailable}/>
          :
          <Fragment>
            <div style={{maxWidth: '500px', maxHeight: '500px', minHeight: "fit-content", overflow: "hidden"}}>
              {/*{window.innerWidth < 769 && (*/}
              {this.props.onFullView && (
                <Button onClick={() => this.props.onFullView && this.props.onFullView()}>Full View</Button>
              )}
              <PinchZoomPan maxScale={2} doubleTapBehavior={'zoom'}>
                <img src={this.props.src}
                     style={!this.state.loaded ? {display: "none"} : {}}
                     onError={() => this.onError()}
                     onClick={(event) => (event.preventDefault(), event.stopPropagation(), this.props.onClick && this.props.onClick())}
                     onLoad={() => this.onLoad()}/>
              </PinchZoomPan>
            </div>
          </Fragment>
        }
      </Fragment>
    )
  }

}


// WEBPACK FOOTER //
// ./src/components/Shared/SafeZoomImage.js